var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangularArray20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.87305,
    y: 1.87292,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.87305,
    y: 8.43689,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.87305,
    y: 15.001,
    width: 3.12601,
    height: 3.12601,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0012,
    y: 1.87292,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0012,
    y: 8.43689,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0012,
    y: 15.001,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.43701,
    y: 1.87292,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.43701,
    y: 8.43689,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.43701,
    y: 15.001,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangularArray20);
export default __webpack_public_path__ + "static/media/rectangular-array_20.8d6138b209f55dcaf5e6cac7e7f48014.svg";
export { ForwardRef as ReactComponent };